const MFSOfficer = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'fso.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Accounts',
    is_heading: true,
    is_active: false,
    link: {
      name: 'fso.accounts'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Leads',
    is_heading: false,
    is_active: false,
    link: {
      name: 'fso.leads'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-poll-people',
    active_icon: 'fad fa-poll-people',
    children: [
      {
        link: {
          name: 'fso.leads.profile'
        }
      }
    ]
  },
  {
    title: 'Customers',
    is_heading: false,
    is_active: false,
    link: {
      name: 'fso.customers'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-user-tie-hair',
    active_icon: 'fad fa-user-tie-hair',
    children: [
      {
        link: {
          name: 'fso.customers.profile'
        }
      }
    ]
  }
]

const MFSOfficerToDos = [
  {
    title: "To Do's",
    is_heading: true,
    is_active: false,
    link: {
      name: 'fso.to-dos'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  // {
  //   title: 'Tasks',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'fso.to-dos.tasks'
  //   },
  //   class_name: '',
  //   collapsable: false,
  //   is_icon_class: true,
  //   icon: 'fat fa-list-check',
  //   active_icon: 'fad fa-list-check',
  //   children: [
  //     {
  //       link: {
  //         name: 'fso.to-dos.tasks.month-comparisons'
  //       }
  //     },
  //     {
  //       link: {
  //         name: 'fso.to-dos.task-events'
  //       }
  //     }
  //   ]
  // },
  // {
  //   title: 'Monthly Plans',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'fso.to-dos.monthly-plans'
  //   },
  //   class_name: '',
  //   collapsable: false,
  //   is_icon_class: true,
  //   icon: 'fat fa-calendar-lines',
  //   active_icon: 'fad fa-calendar-lines'
  // },
  {
    title: 'Activity Recordings',
    is_heading: false,
    is_active: false,
    link: {
      name: 'fso.to-dos.activity-recordings'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-list-tree',
    active_icon: 'fad fa-list-tree'
  },
  {
    title: 'Memo Cascading',
    is_heading: false,
    is_active: false,
    link: {
      name: 'fso.to-dos.customer-memos.pending'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-file-signature',
    active_icon: 'fad fa-file-signature',
    children: [
      {
        link: {
          name: 'fso.to-dos.customer-memos.processing'
        }
      },
      {
        link: {
          name: 'fso.to-dos.customer-memos.history'
        }
      },
      {
        link: {
          name: 'fso.to-dos.customer-memos.documents'
        }
      }
    ]
  }
  // {
  //   title: 'BP Agreements',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'fso.to-dos.bp-agreements.pending'
  //   },
  //   class_name: '',
  //   collapsable: false,
  //   is_icon_class: true,
  //   icon: 'fat fa-handshake',
  //   active_icon: 'fad fa-handshake',
  //   children: [
  //     {
  //       link: {
  //         name: 'fso.to-dos.bp-agreements.processing'
  //       }
  //     },
  //     {
  //       link: {
  //         name: 'fso.to-dos.bp-agreements.history'
  //       }
  //     },
  //     {
  //       link: {
  //         name: 'fso.to-dos.bp-agreements.documents'
  //       }
  //     }
  //   ]
  // }
]

export default MFSOfficer.concat(
  MFSOfficerToDos
)
